import { render, staticRenderFns } from "./HotTag.vue?vue&type=template&id=b8a7de5a&scoped=true&"
import script from "./HotTag.vue?vue&type=script&lang=js&"
export * from "./HotTag.vue?vue&type=script&lang=js&"
import style0 from "./HotTag.vue?vue&type=style&index=0&id=b8a7de5a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8a7de5a",
  null
  
)

export default component.exports